import * as Sentry from "@sentry/browser";
import {BrowserTracing} from "@sentry/tracing";

// init Sentry
try {
    window.Sentry = Sentry;
    Sentry.init({
        dsn: "https://a2385fb0cd724246834d9db75cbb1477@o1042425.ingest.sentry.io/6620036",
        integrations: [new BrowserTracing()],

        tracesSampleRate: 0.5,
    });
} catch (e) {
    console.error('failed to load sentry');
}
